import { createContext, FC } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

import tracker, { Tracker } from 'lib/utils/userTracking/tracker';
import { AppState } from 'lib/types/global';
import { getBranch, getOrgForTracker } from 'lib/store/restaurants/selectors';

const TrackerContext = createContext<Tracker>(tracker);

interface TrackerProviderProps {
  tracker: Tracker;
}

export const TrackerProvider: FC<TrackerProviderProps> = ({
  children,
  tracker,
}) => {
  const { query } = useRouter();

  const branchId = query.branchId as string;
  const orgId = query.orgId as string;

  const mapState = (state: AppState) => ({
    orgDrnId: getOrgForTracker(state, orgId)?.drnId,
    branchDrnId: getBranch(state, branchId)?.drnId,
  });

  const { orgDrnId, branchDrnId } = useSelector(mapState);

  tracker.setExtraContext?.({
    currentBranchDrnId: branchDrnId,
    currentOrgDrnId: orgDrnId,
  });

  return (
    <TrackerContext.Provider value={tracker}>
      {children}
    </TrackerContext.Provider>
  );
};

export default TrackerContext;
